var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 63,
    viewBox: "0 0 61 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2677_12453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 62.5C22.4109 62.5 14.6531 59.2339 8.93324 53.4203C3.21338 47.6067 0 39.7217 0 31.5C0 23.2783 3.21338 15.3933 8.93324 9.57969C14.6531 3.76606 22.4109 0.5 30.5 0.5C38.5891 0.5 46.3469 3.76606 52.0668 9.57969C57.7866 15.3933 61 23.2783 61 31.5C61 39.7217 57.7866 47.6067 52.0668 53.4203C46.3469 59.2339 38.5891 62.5 30.5 62.5ZM24.4 47L51.85 20.65L47.275 16L24.4 37.7L13.725 26.85L9.15 31.5L24.4 47Z",
    fill: "#00BF6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2677_12453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 62,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c94116c611449b3e3db219fe3f0fd1b5.svg";
export { ForwardRef as ReactComponent };